export enum Intensity {
  Negligible = 1,
  Minor = 2,
  Moderate = 3,
  Major = 4,
}

export enum JobStatus {
  Pending = 1,
  Success = 2,
  PartiallySuccess = 3,
  Fail = 4,
}
export enum JobType {
  ProgressReportExport = 1,
  CaseFeedbackExport = 2,
}
